import { Navigate } from "react-router-dom";

import { lazyRoute } from "@/routes/lazy-route";

const InventoryLayout = lazyRoute(() => import("./$inventoryId/inventory.layout"), "InventoryLayout");
const InventoryActivityTabPage = lazyRoute(() => import("./$inventoryId/inventory-activity-tab.page"), "InventoryActivityTabPage");
const InventoryDataTabLayout = lazyRoute(() => import("./$inventoryId/inventory-data-tab.layout"), "InventoryDataTabLayout");
const InventoryDetailTabPage = lazyRoute(() => import("./$inventoryId/inventory-detail-tab.page"), "InventoryDetailTabPage");
const InventoryEvaluationTabPage = lazyRoute(() => import("./$inventoryId/inventory-evaluation-tab.page"), "InventoryEvaluationTabPage");
const InventoryLocalInstallationsTabPage = lazyRoute(() => import("./$inventoryId/local-installation/inventory-local-installations-tab.page"), "InventoryLocalInstallationsTabPage");
const InventoryEmissionFactorsTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/inventory-emission-factors-tab.page"), "InventoryEmissionFactorsTabPage");
const InventorySectorEmissionTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/inventory-emission-output-tab.page"), "InventorySectorEmissionTabPage");
const InventorySectorEnergyConsumptionTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/inventory-energy-consumption-tab.page"), "InventorySectorEnergyConsumptionTabPage");
const InventorySectorMileageTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/inventory-mileage-tab.page"), "InventorySectorMileageTabPage");
const InventorySectorSliceLayout = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/sector-slice/$sectorSliceId/inventory-sector-slice.layout"), "InventorySectorSliceLayout");
const SectorSliceEmissionFactorsTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/sector-slice/$sectorSliceId/sector-slice-emission-factors-tab.page"), "SectorSliceEmissionFactorsTabPage");
const SectorSliceEmissionOutputTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/sector-slice/$sectorSliceId/sector-slice-emission-output-tab.page"), "SectorSliceEmissionOutputTabPage");
const SectorSliceEnergyConsumptionTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/sector-slice/$sectorSliceId/sector-slice-energy-consumption-tab.page"), "SectorSliceEnergyConsumptionTabPage");
const InventorySubsectorLayout = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/subsectors/$subsectorId/inventory-subsector.layout"), "InventorySubsectorLayout");
const SubsectorEmissionFactorsTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/subsectors/$subsectorId/subsector-emission-factors-tab.page"), "SubsectorEmissionFactorsTabPage");
const SubsectorEmissionOutputTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/subsectors/$subsectorId/subsector-emission-output-tab.page"), "SubsectorEmissionOutputTabPage");
const SubsectorEnergyConsumptionTabPage = lazyRoute(() => import("./$inventoryId/sectors/$sectorId/subsectors/$subsectorId/subsector-energy-consumption-tab.page"), "SubsectorEnergyConsumptionTabPage");
const InventorySectorLayout = lazyRoute(() => import("./$inventoryId/sectors/inventory-sector.layout"), "InventorySectorLayout");
const InventoryRootLayout = lazyRoute(() => import("./inventory.root.layout"), "InventoryRootLayout");
const InventoryDashboardPage = lazyRoute(() => import("./inventory-dashboard.page"), "InventoryDashboardPage");
const InventoryListLayout = lazyRoute(() => import("./inventory-list.layout"), "InventoryListLayout");
const InventoryListPage = lazyRoute(() => import("./inventory-list.page"), "InventoryListPage");
const InventoryTrashPage = lazyRoute(() => import("@/domain/trash/routes/inventory-trash.page"), "InventoryTrashPage");

export const inventoryRoutes = [
  {
    path: "inventories",
    element: <InventoryRootLayout />,
    children: [
      {
        path: "",
        element: <InventoryListLayout />,
        children: [
          { path: "", element: <Navigate to="all" replace /> },
          { path: "all", element: <InventoryListPage /> },
          { path: "dashboard", element: <InventoryDashboardPage /> },
          { path: "trash", element: <InventoryTrashPage /> },
        ],
      },
      {
        path: ":inventoryId/",
        element: <InventoryLayout />,
        children: [
          { path: "", element: <Navigate to="details" replace /> },
          { path: "details", element: <InventoryDetailTabPage /> },
          {
            path: "data",
            element: <InventoryDataTabLayout />,
            children: [
              { path: "local-installations", element: <InventoryLocalInstallationsTabPage /> },
              {
                path: "sectors",
                children: [
                  {
                    path: ":sectorId",
                    children: [
                      {
                        path: "",
                        element: <InventorySectorLayout />,
                        children: [
                          { path: "", element: <Navigate to="energy-consumption" replace /> },
                          { path: "energy-consumption", element: <InventorySectorEnergyConsumptionTabPage /> },
                          { path: "emission-factors", element: <InventoryEmissionFactorsTabPage /> },
                          { path: "emissions", element: <InventorySectorEmissionTabPage /> },
                          { path: "mileage", element: <InventorySectorMileageTabPage /> },
                        ],
                      },
                      {
                        path: "sector-slices",
                        children: [
                          {
                            path: ":sectorSliceId",
                            element: <InventorySectorSliceLayout />,
                            children: [
                              { path: "", element: <Navigate to="energy-consumption" replace /> },
                              { path: "energy-consumption", element: <SectorSliceEnergyConsumptionTabPage /> },
                              { path: "emission-factors", element: <SectorSliceEmissionFactorsTabPage /> },
                              { path: "emissions", element: <SectorSliceEmissionOutputTabPage /> },
                            ],
                          },
                        ],
                      },
                      {
                        path: "subsectors",
                        children: [
                          {
                            path: ":subsectorId",
                            element: <InventorySubsectorLayout />,
                            children: [
                              { path: "", element: <Navigate to="energy-consumption" replace /> },
                              { path: "energy-consumption", element: <SubsectorEnergyConsumptionTabPage /> },
                              { path: "emission-factors", element: <SubsectorEmissionFactorsTabPage /> },
                              { path: "emissions", element: <SubsectorEmissionOutputTabPage /> },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          { path: "evaluation", element: <InventoryEvaluationTabPage /> },
          { path: "activity", element: <InventoryActivityTabPage /> },
        ],
      },
    ],
  },
];
